import { render, staticRenderFns } from "./cleaning-log.vue?vue&type=template&id=22978a48&"
import script from "./cleaning-log.vue?vue&type=script&lang=js&"
export * from "./cleaning-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports